import { DatePicker } from "antd";
import DropDown from "../../UIComponents/CustomDropDown/SrtDropDown";
import React, {
  useEffect,
  useLayoutEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import { srtReportGeneration } from "../../Redux/actions/Srt/Srt";
import Button from "../../UIComponents/Button/Button";
import "./Srt.css";
import SrtTabs from "./SrtTabs";
import { toast } from "../../UIComponents/Toast";

const Srt = () => {
  const { RangePicker } = DatePicker;
  const dispatch = useDispatch();
  const styleListData = useSelector((state) => state?.Srf?.srfFilterData);
  const [brandOptions, setBrandOptions] = useState([]);
  // useEffect(() => {
  //   if (styleListData && Array?.isArray(styleListData)) {
  //     const brandArray = styleListData?.map((item) => item?.brand);
  //     setBrandOptions([...new Set(brandArray)]);
  //   }
  // }, [styleListData]);

  const [brandId, setBrandId] = useState();
  const [selectedRange, setSelectedRange] = useState([]);
  const [onSubmitClearDate, setOnSubmitClearDate] = useState([]);
  const [seasonFilter, setSeasonFilter] = useState();
  const [brand, setBrand] = useState();
  const [seasonOptions, setSeasonOptions] = useState([]);
  const seasons = [
    {
      value: "All",
      label: "All",
    },
    {
      value: "F24",
      label: "F24",
    },
    {
      value: "S25",
      label: "S25",
    },
    {
      value: "F25",
      label: "F25",
    },
    {
      value: "S26",
      label: "S26",
    },
    {
      value: "F26",
      label: "F26",
    },
    {
      value: "S27",
      label: "S27",
    },
  ];

  const option = [
    {
      value: "Aims",
      label: "Aims",
    },
    {
      value: "Ayesha",
      label: "Ayesha",
    },
    {
      value: "Beacon",
      label: "Beacon",
    },
    {
      value: "Bonroy",
      label: "Bonroy",
    },
    {
      value: "Crescent pk",
      label: "Crescent pk",
    },
    {
      value: "Denoho",
      label: "Denoho",
    },
    {
      value: "Dynamic",
      label: "Dynamic",
    },
    {
      value: "Enva",
      label: "Enva",
    },
    {
      value: "Evergreen",
      label: "Evergreen",
    },
    {
      value: "Everight",
      label: "Everight",
    },
    {
      value: "Four seasons",
      label: "Four seasons",
    },
    {
      value: "Ideal",
      label: "Ideal",
    },
    {
      value: "Infiiloom",
      label: "Infiiloom",
    },
    {
      value: "Interloop",
      label: "Interloop",
    },
    {
      value: "Kahatex",
      label: "Kahatex",
    },
    {
      value: "Kamal",
      label: "Kamal",
    },
    {
      value: "Keystone",
      label: "Keystone",
    },
    {
      value: "MSL",
      label: "MSL",
    },
    {
      value: "Northeast",
      label: "Northeast",
    },
    {
      value: "Ou wei",
      label: "Ou wei",
    },
    {
      value: "Premium",
      label: "Premium",
    },
    {
      value: "Rong xing",
      label: "Rong xing",
    },
    {
      value: "Royal",
      label: "Royal",
    },
    {
      value: "Royce",
      label: "Royce",
    },
    {
      value: "RRK",
      label: "RRK",
    },
    {
      value: "Salus",
      label: "Salus",
    },
    {
      value: "Slane",
      label: "Slane",
    },
    {
      value: "Spry",
      label: "Spry",
    },
    {
      value: "Super",
      label: "Super",
    },
    {
      value: "Talent",
      label: "Talent",
    },
    {
      value: "Talent Cambodia",
      label: "Talent Cambodia",
    },
    {
      value: "Tauseef",
      label: "Tauseef",
    },
    {
      value: "Textilfort",
      label: "Textilfort",
    },
    {
      value: "Walt",
      label: "Walt",
    },
    {
      value: "Xuren",
      label: "Xuren",
    },
    {
      value: "Yiheng",
      label: "Yiheng",
    },
    {
      value: "Shahzad Textile",
      label: "Shahzad Textile",
    },
    {
      value: "Close Knit",
      label: "Close Knit",
    },
    {
      value: "Superhouse",
      label: "Superhouse",
    },
    {
      value: "Mustaqim",
      label: "Mustaqim",
    }
  ];
  const sortedOptions = [
    { value: "ALL", label: "Select All" },
    ...[...option].sort((a, b) => a.label.localeCompare(b.label)),
  ];
  const brands = [
    {
      value: "All",
      label: "All",
    },
    { 
      value: "DICKI", 
      label: "DICKI" 
    },
    { 
      value: "DICKC", 
      label: "DICKC" 
    },
    { 
      value: "DICKW", 
      label: "DICKW" 
    },
    { 
      value: "DICKG", 
      label: "DICKG" 
    },
    { value: "DCKGW", 
      label: "DCKGW" 
    },
    // {
    //   value: "DCKGU",
    //   label: "DCKGU",
    // },{
    //   value: "DCKIU",
    //   label: "DCKIU",
    // },
    {
      value: "SAUC",
      label: "SAUC",
    },
    {
      value: "EDBR",
      label: "EDBR",
    },
    // {
    //   value: "HAGR",
    //   label: "HAGR",
    // },
    {
      value: "PD",
      label: "PD",
    },
    {
      value: "MFSM",
      label: "MFSM",
    },
    {
      value: "MFSW",
      label: "MFSW",
    },
  ];
  const handleChange = (values) => {
    setBrandId(values && values.length ? values : undefined);
  };
  const onDateChange = (dates, dateString) => {
    setSelectedRange(dateString);
    setOnSubmitClearDate(dates);
  };

  const handleSeasonClear = () => {
    setSeasonFilter();
  }
const onSeasonChange = (values) => {
  if (!values || values.length === 0) {
    setSeasonFilter(undefined);
    return;
  }

  // If Select All clicked
  if (values.includes("ALL")) {
    const allSeasons = seasonOptions
      .filter((item) => item.value !== "ALL")
      .map((item) => item.value);

    setSeasonFilter(allSeasons);
  } else {
    setSeasonFilter(values);
  }
};

  const handleBrandChange = (values) => {
    setBrand(values && values.length ? values : undefined);
  };
  const onSubmitClick = () => {
    if (!seasonFilter) {
      toast.error("!Please select season"); 
    } else if (!brandId) {
      toast.error("!Please select Vendor");
    }
    // else if (selectedRange.length === 0) {
    //   toast.error("!Please select Date range");
    // }
    else {
      dispatch(
        srtReportGeneration(
          brandId,
          selectedRange[0] ? selectedRange[0] : "",
          selectedRange[1] ? selectedRange[1] : "",
          seasonFilter,
          brand
        )
      );
      setBrandId();
      setSeasonFilter();
      setSelectedRange([]);
      setOnSubmitClearDate([]);
      setBrand();
      // setBrandOptions([])
    }
  };
  const handleKeyDown = (event) => {
    // console.log("keyevent", event);
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);

    // Regular expression to match only numeric characters and allowed keys
    const allowedKeys = [
      "Tab",
      "Backspace",
      "Delete",
      "ArrowLeft",
      "ArrowRight",
    ];
    const numericRegex = /^[0-9]*$/;

    if (!numericRegex.test(keyValue) && !allowedKeys.includes(event.key)) {
      event.preventDefault();
    }
  };
  useEffect(() => {
    if (styleListData && Array?.isArray(styleListData)) {
      const uniqueBrands = [
      ...new Set(
        styleListData
          .map((item) => item?.brand?.trim())
          .filter(Boolean)
      ),
    ];

    const formattedBrands = [
      { value: "ALL", label: "Select All" },
      ...uniqueBrands.map((brand) => ({
        value: brand,
        label: brand,
      })),
    ];

    setBrandOptions(formattedBrands);
      console.log("sssssssssssssss", formattedBrands);
      const uniqueSeasons = [
        ...new Set(
          styleListData
          .map((item) => item?.season?.trim().toUpperCase())
          .filter(Boolean)
        ),
      ];
      const formattedSeasons = [
        { value: "ALL", label: "Select All" },
        ...uniqueSeasons.map((season) => ({
          value: season,
          label: season,
        })),
      ];

      setSeasonOptions(formattedSeasons);
    }
  }, [styleListData]);
  const srtScrollPosition = localStorage.getItem("srtAutoScroll");
  const srtApiListingData = localStorage.getItem("srtApiData");

  const containerRef = useRef(null);

  const handleScroll = () => {
    if (containerRef.current) {
      const scrollTop = containerRef?.current?.scrollTop;
      localStorage.setItem("srtAutoScroll", scrollTop);
    }
  };

  const handleScrollButton = () => {
    if (srtScrollPosition) {
      window.scrollTo({
        top: containerRef?.current?.offsetTop,
      });
      containerRef?.current?.scrollTo({
        top: srtScrollPosition,
      });
    }
  };

  useLayoutEffect(() => {
    handleScrollButton();
  }, [srtApiListingData]);

  // useEffect(() => {
  //   console.log("scroll position of localstorage", srtScrollPosition);
  //   handleScrollButton();
  // }, [srtApiListingData]);

  return (
    <div
      ref={containerRef}
      onScroll={handleScroll}
      className="srt-main-wrapper"
    >
      <div className="report-generation-top-wrapper">
        <p className="report-generation-label">Report Generation</p>
        <div className="report-generation-top-container srt-report-filters">
          <div className="brand-drop-down">
            <DropDown
              mode="multiple"
              allowClear
              placeholder={"Brand"}
              options={brandOptions}
              value={brand}
              onChange={handleBrandChange}
              enableSelectAll
            />
          </div>
          <div className="dickies-drop-down-one">
            <DropDown
              mode="multiple"
              allowClear
              onChange={onSeasonChange}
              placeholder={"Season"}
              options={seasonOptions}
              value={seasonFilter}
              enableSelectAll
            />
          </div>
          <div className="srt-first-drop-down">
            <DropDown
              mode="multiple"
              allowClear
              placeholder={"Vendor"}
              options={sortedOptions}
              value={brandId}
              onChange={handleChange}
              enableSelectAll
            />
          </div>
          <div className="range-picker-container">
            <RangePicker
              onKeyDown={handleKeyDown}
              allowClear={false}
              format={"MM/DD/YYYY"}
              onChange={onDateChange}
              value={onSubmitClearDate}
            />
          </div>
          <Button
            onClick={onSubmitClick}
            className="submit-buttom"
            children={"SUBMIT"}
          />
        </div>
      </div>
      <SrtTabs containerRef={containerRef}/>
    </div>
  );
};

export default Srt;
